import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./yieldSummaryTable.module.scss";

const YieldSummaryTable = ({ dataObject }) => {
  const { t } = useTranslation();
  if (!dataObject) {
    return null;
  }

  const rows = [
    {
      label: t("portfolio.distribuzioneProventi"),
      total: dataObject.monthly_distribution.toFixed(2),
      bonds: "-",
    },
    {
      label: t("portfolio.yieldToMaturity"),
      total: dataObject.ytm_total.toFixed(2),
      bonds: dataObject.ytm_obbligazioni || "0,00",
    },

    {
      label: t("portfolio.durationAnni"),
      total: dataObject.duration_total.toFixed(2),
      bonds: dataObject.duration_obbligazioni || "0,00",
    },
  ];

  return (
    <table className={styles.distribuzioneProventiTable}>
      <tbody>
        {rows.map((row, index) => (
          <tr key={index}>
            <td>{row.label}</td>
            <td>{row.total}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default YieldSummaryTable;
